export default __webpack_public_path__ + "static/media/2.111718c9.jpg";